module.exports = __webpack_public_path__ + "static/img/图层 564.47425458.png";